import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '玉泉山关陵景区官方网站'
          }
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '玉泉山'
          }
        },  {
          path: '/guanling',
          name: 'guanling',
          component: resolve => require(['@/view/GuanLing'], resolve),
          meta: {
            title: '关陵'
          }
        },  {
          path: '/scenicSpotDetail/:id',
          name: 'scenicSpotDetail',
          component: resolve => require(['@/view/scenicSpotDetail'], resolve),
          meta: {
            title: '景点详情'
          }
        },{
          path: '/recentnews',
          name: 'recentnews',
          component: resolve => require(['@/view/RecentNews'], resolve),
          meta: {
            title: '最新动态'
          }
        },{
          path: '/jqhdDetail/:id/:type',
          name: 'jqhdDetail',
          component: resolve => require(['@/view/jqhdDetail'], resolve),
          meta: {
            title: '最新动态详情'
          }
        }, {
          path: '/playguide',
          name: 'playguide',
          component: resolve => require(['@/view/PlayGuide'], resolve),
          meta: {
            title: '游玩攻略'
          }
        }, {
          path: '/ywglDetail',
          name: 'ywglDetail',
          component: resolve => require(['@/view/ywglDetail'], resolve),
          meta: {
            title: '游玩攻略'
          }
        }, {
          path: '/oneClickReserve',
          name: 'oneClickReserve',
          component: resolve => require(['@/view/OneClickReserve'], resolve),
          meta: {
            title: '一键预定'
          }
        }, {
          path: '/reserveList/:id/:name',
          name: 'reserveList',
          component: resolve => require(['@/view/reserveList'], resolve),
          meta: {
            title: '预定列表'
          }
        }, {
          path: '/oneClickNavigation',
          name: 'oneClickNavigation',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '一键导航'
          }
        }, {
          path: '/MessageBoard',
          name: 'MessageBoard',
          component: resolve => require(['@/view/MessageBoard'], resolve),
          meta: {
            title: '留言互动'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        },
        {
          path: '/businessCooperation',
          name: 'businessCooperation',
          component: resolve => require(['@/view/businessCooperation'],resolve),
          meta: {
            title: '招商合作'
          }
        },{
          path: '/zsDetail/:id',
          name: 'zsDetail',
          component: resolve => require(['@/view/zsDetail'], resolve),
          meta: {
            title: '招商合作详情'
          }
        },
        {
          path: '/talentWanted',
          name: 'talentWanted',
          component: resolve => require(['@/view/talentWanted'],resolve),
          meta: {
            title: '诚聘英才'
          }
        },
        {
          path: '/callus',
          name: 'callus',
          component: resolve => require(['@/view/callus'], resolve),
          meta: {
            title: '联系我们'
          }
        },
      ]
    },
    {
      path: '/glIndex',
      name: 'glIndex',
      component: resolve => require(['@/view/glIndex'], resolve)
    }
  ],
  
})



// WEBPACK FOOTER //
// ./src/router/index.js